/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CHR_WALLETS_ITEM = {
  id: 'checks_sidebar_wallets',
  screenId: 'fin-chr-wallets',
  label: 'Carteras',
  description: 'Agrupación de cheques recibidos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Las carteras organizan los cheques recibidos (por ejemplo «Cartera general» o por sucursal). Al cobrar con cheque de tercero elegís en qué cartera queda.',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'Creá al menos una cartera antes de registrar cobros con cheque, para poder asignarlos.',
        ],
      },
      {
        title: 'Lista',
        bullets: [
          'Columnas: ID, Descripción, Moneda.',
          'Tocá una fila para ver el detalle de la cartera (solo lectura).',
          'Podés exportar el listado.',
        ],
      },
      {
        title: 'Alta de cartera',
        intro: 'El botón + abre «Nueva cartera». Campos:',
        fields: [
          { label: 'Descripción', description: 'Nombre interno. Obligatorio.' },
          { label: 'Moneda', description: 'Moneda de los cheques que guardarás en esta cartera. Obligatoria.' },
        ],
        paragraphs: [
          'Tocá «Crear cartera» para confirmar. En esta pantalla no hay edición: solo alta y consulta.',
        ],
      },
    ],
  },
}
